<!--

events:
    - show-bookmark-remind:  如果使用者沒有權限且點擊了詞彙分詞提醒時。
-->
<template lang="html">
    <div class="pt-1 videoCaptionsData-wrap caption-scroller-panel">
        <div class="flex-between w-100">
            <select class="form-select translation-btn" aria-label="Default select example" v-model="captionMode">
                <option :value="1">{{$t('element_video_caption_list.caption_translated')}}&nbsp;&nbsp;</option>
                <option :value="2">{{$t('element_video_caption_list.caption_original_translated')}}&nbsp;&nbsp;</option>
                <option :value="3">{{$t('element_video_caption_list.caption_original')}}&nbsp;&nbsp;</option>
            </select>
            <span v-if="tm.RepLexicon">
                {{fmtRepLexiconTitle}}
            </span>
        </div>
        <!-- <div class="flex-between w-100"><button id="hideZhBtn" v-on:click="hideZhBtn" class="hideZhBtn btn">隱藏翻譯</button><i class="fas fa-share-alt-square"></i></div> -->
        <div :id="'sentence_div_' + cap.No" v-show="isSentenceVisible(cap)"
             class="mb-4 videoCaptionsData-text videoText-List" :class="[(cap.Id == playingCaptionId) ?'playing-caption':'']"
             v-for="(cap, capIdx) in videoCaptions" @click="playCaptionClicked($event, cap, capIdx);" style="cursor:pointer;"
             :key="cap.Id">
            <img v-if="cap.IsUserCorpus" alt="" class="videoCaptionsData-heart-icon-active" @click="toggleUserCorpus(cap)"
                 src="@/assets/image/CaptionCorpus-heart-icon-active.svg">
            <img v-else alt="" class="videoCaptionsData-heart-icon" src="@/assets/image/CaptionCorpus-heart-icon.svg"
                 @click="toggleUserCorpus(cap)">
            <p v-if="cap.tokenizedCaption" class="videoCaptionsData-title" :class="[playingCaptionId==cap.Id?'playing-caption':'']">
                <span v-for="(t, idx) in cap.tokenizedCaption.Tokens" :key="idx" v-on:click="openLexAdvInfo(t)"
                      class="mr-1" :class="[t.HashedId?'lookup-lex':'', t.IsPhrase?'phrase':'']" v-html="t.Title"></span>
                <i class="fas fa-microphone video-caption-play-icon" v-on:click="sendCaptionShadowningRequest(cap, capIdx);"></i>
            </p>
            <p v-else class="videoCaptionsData-title" v-on:click="tokenizeCaptionClicked(cap)">{{cap.Text
                }}<i class="fas fa-microphone video-caption-play-icon" v-on:click="playCaptionClicked($event, cap, capIdx);"></i></p>
                <p class="videoCaptionsData-lgZh" v-if="isTranslationVisible(cap)">{{dictTMCS[cap.Id].TextTranslated}}</p>
</div>
    </div>
</template>

<script>
    import MobileDetect from 'mobile-detect';
    import Vue from 'vue';
    import { ghelper } from '@/lib/ghelper';
    import "@/assets/scss/TokenizedCaption.scss";

    import CaptionTokenizer from '@/components/Plugins/CaptionTokenizer.js';
    Vue.use(CaptionTokenizer);

    export default {
        props: {
            user: {
                type: Object,
                default: null,
            },
            tm: {
                type: Object,
                default: function () { return {} }
            },
            videoCaptions: {
                type: Array,
                default: function () { return [] }
            },
            dictVideoCaptions: {
                type: Object,
                default: function () { return {} }
            },
            scrollPosMobile: {
                type: Number,
                default: 2,
            },
            scrollPosDesktop: {
                type: Number,
                default: 3,
            },
            dictTMCS: {
                type: Object,
                default: function () { return {} }
            },
            dictTMLS: {
                type: Object,
                default: function () { return {}; }
            },
            videoShareInfo: {
                type: Object,
                default: null,
            }
        },
        data: function () {
            return {
                isPhone: null,

                playingCaption: null,
                playingCaptionId: null,
                filterTranslation: false,
                needToScrollToCaption: null,
                firstTranslatedCaption: null,
                lastTranslatedCaption: null,

                captionMode: 1,
            };
        },
        methods: {
            sendCaptionShadowningRequest: function (cap, capIdx) {
                this.$emit('caption-shadowing-request', cap, capIdx);
            },
            isTranslationVisible: function (cap) {
                if ((this.captionMode == 1 || this.captionMode == 2) && this.dictTMCS && (cap.Id in this.dictTMCS)) {
                    return true;
                }

                return false;
            },
            isSentenceVisible: function (cap) {
                switch (this.captionMode) {
                    case 1: // 已翻譯字幕
                        if (this.dictTMCS && cap.Id in this.dictTMCS) {
                            return true;
                        }
                        break;

                    case 2: // 所有原文+翻譯
                        return true;

                    case 3: // 所有原文
                        return true;
                    default:
                        this.$dialog.alert('Unknown caption mode');
                        break;
                }

                return false;
            },
            fmtCapText: function (cap) {
                if (cap.renderredSentence) {
                    return cap.renderredSentence;
                }

                return cap.Text;
            },
            openLexAdvInfo: function (cap) {
                if (this.videoShareInfo) {
                    // from videoshare
                    this.$gtag.event('open_lex_adv_info', {
                        'event_category': 'iyuyan',
                        'event_label': 'video_share',
                        'value': 200
                    });
                } else {
                    this.$gtag.event('open_lex_adv_info', {
                        'event_category': 'iyuyan',
                        'event_label': 'material_study',
                        'value': 200
                    });
                }

                if (this.user) {
                    /* 先關閉點數限制 */
                    /*
                    if (this.tm.IsCollected) {
                        if (cap.HashedId) {
                            let appUrl = ghelper.getActionUrl('AdvInfo', 'Lex');
                            let urlFull = appUrl + '/' + cap.HashedId + '/' + this.tm.LangCharsetCodeTranslated;
                            window.open(urlFull, '_blank');
                        }
                    } else {
                        this.$emit('show-bookmark-remind');
                    }*/

                    if (cap.HashedId) {
                        let appUrl = ghelper.getActionUrl('AdvInfo', 'Lex');
                        let urlFull = appUrl + '/' + cap.HashedId + '/' + this.tm.LangCharsetCodeTranslated;
                        window.open(urlFull, '_blank');
                    }
                } else {
                    let loginHint = this.$t('page_material_study.login_hint');
                    this.$dialog.alert(loginHint);
                }
            },
            hideZhBtn: function () {
                let btnText = document.getElementById("hideZhBtn").textContent
                if (btnText == '隱藏翻譯') {
                    var el = document.querySelectorAll(".videoCaptionsData-lgZh");
                    for (let i = 0; i < el.length; i++) {
                        el[i].classList.add("hiddenBtn");
                    }
                    document.getElementById("hideZhBtn").textContent = '顯示翻譯'
                } else if (btnText == '顯示翻譯') {
                    let elshow = document.querySelectorAll(".videoCaptionsData-lgZh");
                    for (var i = 0; i < elshow.length; i++) {
                        elshow[i].classList.remove("hiddenBtn");
                    }
                    document.getElementById("hideZhBtn").textContent = '隱藏翻譯'
                }
            },
            toggleUserCorpus: async function (vc) {
                if (this.videoShareInfo) {
                    // from videoshare
                    this.$gtag.event('toggle_user_corpus', {
                        'event_category': 'iyuyan',
                        'event_label': 'video_share',
                        'value': 200
                    });
                } else {
                    this.$gtag.event('toggle_user_corpus', {
                        'event_category': 'iyuyan',
                        'event_label': 'material_study',
                        'value': 200
                    });
                }

                if (this.user) {
                    /* 先關閉 */
                    /*
                    if (this.tm.IsCollected) {
                        if (vc.IsUserCorpus) {
                            await this.userCorpusDeleteBS(vc);
                        } else {
                            await this.userCorpusCreate(vc);
                        }
                    } else {
                        this.$emit('show-bookmark-remind');
                    }*/

                    if (vc.IsUserCorpus) {
                        await this.userCorpusDeleteBS(vc);
                    } else {
                        await this.userCorpusCreate(vc);
                    }
                } else {
                    let loginHint = this.$t('page_material_study.login_hint');
                    this.$dialog.alert(loginHint);
                }
                
            },
            userCorpusCreate: async function (vc) {
                var loader = this.$loading.show();

                try {
                    let res = await this.axios.post("Data/UserCorpusCreate", {
                        cid: vc.Id,
                    });

                    let data = res.data;

                    if (data.success) {
                        this.$set(vc, 'IsUserCorpus', true);
                    } else {
                        this.$dialog.alert(data.message);
                    }
                    loader.hide();
                } catch (error) {
                    if (error.response) {
                        // 當狀態碼不在 validateStatus 設定的範圍時進入, 401 感覺會跑來這。待確認
                        // 有 data / status / headers 參數可用
                        console.log(error.response.status);
                    } else if (error.request) {
                        // 發送請求，但沒有接到回應
                        // error.request is an instance of XMLHttpRequest in the browser
                        // and an instance of http.ClientRequest in node.js
                        console.log(error.request);
                    } else {
                        // 在設定 request 時出錯會進入此
                        console.log("Error", error.message);
                    }
                    this.$dialog.alert("無法建立使用者最愛語料。發生不知名的錯誤");
                    loader.hide();
                }
            },
            userCorpusDeleteBS: async function (vc) {
                var loader = this.$loading.show();

                try {
                    let res = await this.axios.post("Data/UserCorpusDeleteBS", {
                        cid: vc.Id,
                    });

                    let data = res.data;

                    if (data.success) {
                        this.$set(vc, 'IsUserCorpus', false);
                    } else {
                        this.$dialog.alert(data.message);
                    }
                    loader.hide();
                } catch (error) {
                    if (error.response) {
                        // 當狀態碼不在 validateStatus 設定的範圍時進入, 401 感覺會跑來這。待確認
                        // 有 data / status / headers 參數可用
                        console.log(error.response.status);
                    } else if (error.request) {
                        // 發送請求，但沒有接到回應
                        // error.request is an instance of XMLHttpRequest in the browser
                        // and an instance of http.ClientRequest in node.js
                        console.log(error.request);
                    } else {
                        // 在設定 request 時出錯會進入此
                        console.log("Error", error.message);
                    }
                    this.$dialog.alert("無法刪除使用者最愛語料。發生不知名的錯誤");
                    loader.hide();
                }
            },
            queueCaptionTokenization: function (caption) {
                var startIndex = caption.No - 1;
                var preTokenizeSize = 10;
                var queueCount = 0;

                // maintain the tokenzing queue
                for (var i = 0; i < preTokenizeSize && queueCount < preTokenizeSize; i++) {
                    if (startIndex + i >= this.videoCaptions.length) {
                        break;
                    }

                    var curCaption = this.videoCaptions[startIndex + i];

                    if (this.$CaptionService.tokenizeCaption(this.tm.Id, curCaption)) {
                        queueCount++;
                    }
                }
            },
            tokenizeCaptionClicked: function (cap) {
                this.queueCaptionTokenization(cap);
            },
            playCaptionClicked: function (event, cap, capIdx) {
                this.playingCaption = cap;
                this.playingCaptionId = cap.Id;
                this.$emit('caption-clicked', event, cap, capIdx);
            },
            // we will do 2 jobs here , 1. scrollTo the playing caption 2. update the playing caption indicator(if skipScoll is false)
            gotoCaption: function (cap, skipScroll) {
                // tokenizing following captions
                this.queueCaptionTokenization(cap);

                if (!skipScroll) {
                    this.scrollToCaption(cap);
                }

                // 2. update the playing caption indicator
                this.playingCaptionId = cap.Id;
            },
            scrollToCaption: function (cap) {
                // 1. scrollTo the playing caption while the player is playing
                /*
                var captionNoTo = this.isPhone ? cap.No - (this.scrollPosMobile - 1)
                    : cap.No - (this.scrollPosDesktop - 1);

                if (captionNoTo <= 0) {
                    captionNoTo = 1;
                }
                */
                if (this.captionMode == 1) {
                    // in the mode of showing the translated caption only
                    if (this.dictTMCS && !(cap.Id in this.dictTMCS)) {
                        return; // skip the scolling
                    }
                }

                var capIndex = this.dictVideoCaptions[cap.Id].idx;
                var capIdxTo = this.isPhone ? capIndex - (this.scrollPosMobile - 1)
                    : capIndex - (this.scrollPosDesktop - 1);
                if (capIdxTo < 0) {
                    capIdxTo = 0;
                }

                var capTo = this.videoCaptions[capIdxTo];
                if (this.filterTranslation) {
                    var lastTranslatedIndex = this.dictVideoCaptions[this.lastTranslatedCaption.Id].idx;
                    while (capTo && !capTo.isTranslated) {
                        // it's possible isTranslated is not set if the original caption is empty,
                        // find the next translated caption to scroll to
                        var nextIndex = this.dictVideoCaptions[capTo.Id].idx + 1;
                        if (nextIndex <= lastTranslatedIndex) {
                            capTo = this.videoCaptions[nextIndex];
                        } else {
                            capTo = null;
                        }
                    }
                }

                if (capTo) {
                    var captionNoTo = capTo.No;

                    /* ideas from: https://stackoverflow.com/questions/2905867/how-to-scroll-to-specific-item-using-jquery */
                    var $container = $(".caption-scroller-panel");
                    var $scrollTo = $('#sentence_div_' + captionNoTo);

                    if ($scrollTo.offset() && $container.offset) {
                        $container.scrollTop(
                            $scrollTo.offset().top - $container.offset().top + $container.scrollTop()
                        );
                    }
                }

            },
            // 改變select的寬度
            selectChangeWidth: function () {
                const select = document.querySelector('select')

                select.addEventListener('change', (event) => {
                    let tempSelect = document.createElement('select'),
                        tempOption = document.createElement('option');

                    tempOption.textContent = event.target.options[event.target.selectedIndex].text;
                    tempSelect.style.cssText += `
                    visibility: hidden;
                    position: fixed;
                    `;
                    tempSelect.appendChild(tempOption);
                    event.target.after(tempSelect);

                    const tempSelectWidth = tempSelect.getBoundingClientRect().width;
                    event.target.style.width = `${tempSelectWidth}px`;
                    tempSelect.remove();
                });

                select.dispatchEvent(new Event('change'));
            }
        },
        mounted: function () {
            var md = new MobileDetect(window.navigator.userAgent);
            this.isPhone = md.phone();

            if (this.videoCaptions) {
                this.queueCaptionTokenization(this.videoCaptions[0]);
            }
            this.selectChangeWidth()
        },
        watch: {
            videoCaptions: function (newVal) {
                if (newVal && newVal.length > 0) {
                    this.queueCaptionTokenization(newVal[0]);
                }
            }
        },
        computed: {
            fmtRepLexiconTitle: function () {
                if (this.tm && this.tm.RepLexicon) {
                    return this.$t('element_video_caption_list.rep_lexicon') + '： ' + this.tm.RepLexicon.Title;
                }

                return null;
            }
        },
    };
</script>

<style lang="css">
    .phrase {
        border-bottom: 2px solid red;
    }

    .videoCaptionsData-wrap {
        overflow-y: scroll;
        height: 460px;
        padding: 0px 30px;
    }

    .videoCaptionsData-text {
        position: relative;
        font-size: 1.2rem;
    }

        .videoCaptionsData-text:nth-child(1) p {
            margin-top: 0px;
        }

    .playing-caption {
        background-color: rgb(243, 243, 243);
        border-radius: 5px;
        zoom: 1.1;
    }

    .videoCaptionsData-heart-icon {
        width: 18px;
        position: absolute;
        top: 5px;
        left: -25px;
        opacity: 0;
    }

    .videoCaptionsData-heart-icon-active {
        width: 18px;
        position: absolute;
        top: 5px;
        left: -25px;
    }

    .video-caption-play-icon {
        /*
        content: url('~@/assets/image/videoCaptions-voice.svg');
        */
        /*
        width: 50px;
        height: 50px;
        */
        margin-left: 6px;
        opacity: 0;
    }

    .videoCaptionsData-text:hover .videoCaptionsData-heart-icon, .videoCaptionsData-text:hover .video-caption-play-icon {
        opacity: 1;
        cursor: pointer;
    }

    .playing-caption .video-caption-play-icon {
        opacity: 1 !important;
    }

    .videoCaptionsData-tag {
        color: #4598EB;
        cursor: pointer;
    }

        .videoCaptionsData-tag span:hover {
            opacity: .6;
        }

        .videoCaptionsData-tag span {
            margin-right: 8px;
        }

    .hiddenBtn {
        display: none;
    }

    .hideZhBtn {
        border: 2px solid #456CEB;
        color: #456CEB;
        border-radius: 50px;
        margin-bottom: 15px;
    }

    .translation-btn {
        border: 2px solid #456CEB;
        color: #456CEB;
        border-radius: 50px;
        padding: 5px 0px 5px 10px;
        cursor: pointer;
        margin-left: 0px;
        margin-bottom: 0px;
        font-size: 14px !important;
    }

        .translation-btn:hover {
            color: #fff;
            background-color: #456CEB;
        }

        .translation-btn:focus {
            box-shadow: 6px;
        }

    .videoCaptionsData-title {
        margin-bottom: 1px !important;
        margin-top: 17px !important;
        font-weight: 600 !important;
    }


    :focus-visible {
        outline: -webkit-focus-ring-color auto 0px !important;
    }


    .hideZhBtn:hover {
        color: #fff;
        background-color: #456CEB;
    }

    @media screen and (max-width:700px) {
        .videoCaptionsData-wrap {
            overflow-y: none;
            height: auto;
            padding: 0px 0px;
            margin-top: 30px;
        }
    }
</style>